export default "__VITE_ASSET__BdAlVKFW__"